import { CORA_UI } from "@/constants/cora";

export interface CoraAvatarProps {
  /** Diameter in px. */
  size: number;
}

/** Cora's round photo. Decorative: it always sits next to her name or her own message. */
export function CoraAvatar({ size }: CoraAvatarProps) {
  return (
    <img
      src={CORA_UI.AVATAR_SRC}
      alt=""
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className="block shrink-0 rounded-full bg-light-dust object-cover"
    />
  );
}

export default CoraAvatar;
